import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage, loadLanguage } from "../../redux/reducers/language";

const LanguageSwitcher = () => {
  const dispatch = useDispatch();
  const currentLanguage = useSelector(
    (state) => state.language.currentLanguage
  );
  const [isAnimating, setIsAnimating] = useState(false);

  const toggleLanguage = () => {
    if (isAnimating) return;

    setIsAnimating(true);

    // First stage: fade out
    setTimeout(() => {
      const newLanguage = currentLanguage === "english" ? "hindi" : "english";
      dispatch(setLanguage(newLanguage));
      dispatch(loadLanguage(newLanguage));

      // Second stage: fade in
      setTimeout(() => {
        setIsAnimating(false);
      }, 300);
    }, 300);
  };

  return (
    <div className="inline-block max-w-[30vw]">
      <button
        onClick={toggleLanguage}
        className="flex items-center rounded-full overflow-hidden border border-gray-200 bg-[#E6E6E6] shadow-sm transition-all duration-300 hover:shadow-md"
        disabled={isAnimating}
      >
        <div
          className={`max-w-[15vw] px-4 sm:px-4 py-2 sm:py-1 font-medium text-xs sm:text-sm transition-all duration-300 ${
            currentLanguage === "english"
              ? "bg-orange-600 rounded-full m-1 text-white"
              : "text-custom-maroon"
          } ${
            isAnimating
              ? "opacity-0 transform scale-90"
              : "opacity-100 scale-100"
          }`}
        >
          En
        </div>
        <div
          className={`max-w-[15vw] px-4 sm:px-4 py-2 sm:py-1 font-medium text-xs sm:text-sm transition-all duration-300 ${
            currentLanguage === "hindi"
              ? "bg-orange-600 rounded-full m-1 text-white"
              : "text-custom-maroon"
          } ${
            isAnimating
              ? "opacity-0 transform scale-90"
              : "opacity-100 scale-100"
          }`}
        >
          हिं
        </div>
      </button>
    </div>
  );
};

export default LanguageSwitcher;
